export const ModalActiveThemeAppExtension = {
  modal_heading: 'Veda Builder chưa được bật!',
  modal_content_title: 'Dữ liệu trang đã được lưu vào Veda. Nhưng bạn cần kích hoạt ứng dụng để cập nhật thay đổi trong cửa hàng của bạn',
  modal_content_description: 'Nhấp nút "Bật ứng dụng" để bật ứng dụng Veda Builder',
  modal_button: 'Bật ứng dụng',
} as const;
